import Icon from '../components/Icon.vue'

Icon.register({"bar-chart":{"width":2048,"height":1792,"paths":[{"d":"M640 896v512h-256v-512h256zM1024 384v1024h-256v-1024h256zM2048 1536v128h-2048v-1536h128v1408h1920zM1408 640v768h-256v-768h256zM1792 256v1152h-256v-1152h256z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bar-chart.js
// module id = 1176
// module chunks = 0